/* eslint-disable class-methods-use-this */ import { UIMSceneEnum } from '../../../shared/enums/UIMSceneEnums.ts';
import { SocketLobbySend } from '../../shared/scripts/socket/SocketLobbySend.ts';
import { SocketActionController } from '../../shared/scripts/socket/SocketActionController.ts';
import { UIUrlController } from '../../shared/scripts/ui_html/UIUrlController.ts';
import { EntryMobileUrlParameterController } from './EntryMobileUrlParameterController.ts';
import { logError } from '../../shared/scripts/ui_utils/Utils.ts';
export class UIMSocketEventHandler extends SocketActionController {
    onStateSessionState() {
        const isAccessGameFromLinkHandledByRoom = this.uiManager.createRoomController.isUserOnCreateRoomFlow();
        if (!isAccessGameFromLinkHandledByRoom) {
            UIUrlController.accessGameFromLink(async (roomId)=>{
                await SocketLobbySend.accessGameFromLink(roomId);
            });
        }
    }
    onConnectionEstablished(data) {
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game);
        EntryMobileUrlParameterController.removeParameter();
        window.location.hash = data.gameSettingId;
    }
    onStateInitialPlacement() {
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game);
    }
    onMatchmakingUpdate(matchmakingStatusUpdate) {
        const matchmakingSelectionController = this.uiManager.mainpageController.bodyController.homepageController.matchmakingController;
        matchmakingSelectionController.updateMatchmakingStatus(matchmakingStatusUpdate);
    }
    onMatchmakingError(error) {
        this.uiManager.mainpageController.bodyController.homepageController.showMatchmakingError(error);
    }
    onChannelRoomUpdate(roomData) {
        logError('onChannelRoomUpdate', [
            'No channel room update on mobile'
        ]);
    }
    onRoomListUpdate(data) {
        this.uiManager.mainpageController.bodyController.lobbyController.updateRoomList(data);
    }
    constructor(uiGameManager, uiManager, generalServicesController){
        super(generalServicesController);
        this.uiGameManager = uiGameManager;
        this.uiManager = uiManager;
    }
}
